export default {
  orgCount: '参与企业',
  businessCount: '业务总量',
  applyCount: '数模总数',
  interfaceCount: '接口总数',
  evidenceCount: '区块链存证',
  verifyCount: '区块链验证',
  shareTotal: '共享总数',
  realTimeLog: '实时日志',
  top10: '企业使用 Top10',
  orgName: '企业名称',
  digifaxTitle: '数模（发送｜接收）',
  apiCall: '接口调用',
  orgUseTitle: '近1月新增调用量',
  api: '接口',
  digifax: '数模',
  blockchainStatistics: '区块链统计',
  linkFile: '上链文件',
  uplinkData: '上链数据',
  behavioralCertificate: '行为存证'
};



// WEBPACK FOOTER //
// ./src/views/screen/screen.zh-CN.js